import type { DashboardSecurityEventInput } from '@pos/types';

import { useSession } from '../stores/session';
import { useUi } from '../stores/ui';

const apiBaseUrl = (): string =>
  (import.meta.env.VITE_API_BASE_URL as string | undefined)?.replace(
    /\/$/,
    '',
  ) ?? 'http://localhost:8787';

export function appendPermissionDeniedAudit(action: string): void {
  const token = useSession.getState().token;
  if (!token) return;
  const branchId = useUi.getState().branchId ?? undefined;
  const body: DashboardSecurityEventInput = {
    event: 'permission_denied',
    action: action.slice(0, 128),
    path: window.location.pathname.slice(0, 256),
    branchId,
  };
  void fetch(`${apiBaseUrl()}/dashboard/audit-events`, {
    method: 'POST',
    headers: {
      authorization: `Bearer ${token}`,
      'content-type': 'application/json',
    },
    body: JSON.stringify(body),
  }).catch(() => undefined);
}
